export default {
  tags: [],
  select_tag: {},
};
